import React from 'react';
import styles from './Footer.module.scss';
import Callout from '../../Callout';
import Text from '../../Text';
import cx from 'classnames';

export interface FooterProps {
  disclaimer?: React.ReactElement;
  footerButtons: React.ReactNode;
  maxWidthMobile: boolean;
  maxWidthSmallDesktop: boolean;
  smallViewport: boolean;
}

export const Footer: React.FC<FooterProps> = ({
  disclaimer,
  footerButtons,
  maxWidthMobile,
  maxWidthSmallDesktop,
  smallViewport,
}) => {
  return (
    <div className={styles.footer}>
      {disclaimer != null && (
        <>
          <div className={styles.disclaimer}>
            <Text>{disclaimer}</Text>
          </div>
          <Callout className={styles.disclaimerCallout}>{disclaimer}</Callout>
        </>
      )}
      {footerButtons && (
        <div
          className={cx(
            styles.buttonContainer,
            maxWidthMobile && styles.maxWidthMobile,
            maxWidthSmallDesktop && styles.maxWidthSmallDesktop,
          )}
        >
          {React.Children.map(
            footerButtons,
            (button, idx) =>
              React.isValidElement(button) &&
              React.cloneElement(button, {
                centered: true,
                inline: !smallViewport,
                wide: smallViewport || maxWidthMobile || maxWidthSmallDesktop,
                className: cx(button.props.className, styles.footerButton),
                ...button.props,
                key: `modal-button-${idx}`,
              }),
          )}
        </div>
      )}
    </div>
  );
};

export default Footer;
